// 解析应用数据
export function resolveApps(apps) {
  if (!apps) return []

  if (apps instanceof Object) {
    apps = [apps]
  }

  const qiankunApps = apps?.map(item => {
    const { name, homePage, agentId } = item
    return {
      name,
      entry: window?.__SAAS_APP_CONFIG__?.microUrl?.concat(agentId + '/') || homePage,
      container: '#frame', // 规定应用编码添加 _ca 后缀的应用自定义布局
      activeRule: '/' + agentId
    }
  })

  return qiankunApps || []
}
